import { ProductController, UserController } from "controllers";

/**
 *
 * @param {*} barcode
 * @param {*} replacementBarcode
 * @param {*} boxId
 */
const swapLog = async (barcode, replacementBarcode, boxId) => {
    const log = await ProductController.getLogByBoxId(barcode, boxId);

    await ProductController.setProductLogByBoxId(replacementBarcode, boxId, log);
    await ProductController.deleteProductLog(barcode, boxId);
};

/**
 *
 * @param {*} barcode
 * @param {*} replacementBarcode
 * @param {*} userId
 * @param {*} boxId
 */
const swapItem = async (barcode, replacementBarcode, userId, boxId) => {
    const item = await UserController.getUserBoxItemByProductBarcode(userId, boxId, barcode);
    const { name, imageURLs } = await ProductController.getProductByBarcode(replacementBarcode);

    const payload = { name, description: name, barcode: replacementBarcode, imageURL: imageURLs[0], status: 'at_customer' };

    await UserController.setUserBoxItem(userId, boxId, item.id, payload);
};

export const isReplacementProductAvailable = async (barcode) => {
    if (!barcode) {
        return false;
    }

    const { status } = await ProductController.getProductByBarcode(barcode);
    return status === 'available';
}

/**
 *
 * @param {*} barcode
 * @param {*} replacementBarcode
 * @returns
 */
export const replace = async (barcode, replacementBarcode) => {
    const { currentUser, currentBox, status } = await ProductController.getProductByBarcode(barcode);

    // switch the log to the replacement product
    await swapLog(barcode, replacementBarcode, currentBox);

    // update products
    await ProductController.editProduct(replacementBarcode, { currentUser, currentBox, status });
    await ProductController.editProduct(barcode, { currentUser: null, currentBox: null, status: 'available' });

    // swap box items
    await swapItem(barcode, replacementBarcode, currentUser, currentBox);
};
